import * as React from 'react';
import { cn } from '@/lib/utils';

const DuelNotification = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-notification',
      // Estilos base
      'rounded-lg bg-primary-light text-white',
      'flex items-start gap-6 p-[30px]',
      className
    )}
    {...props}
  />
));
DuelNotification.displayName = 'DuelNotification';

const DuelNotificationContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-notification-content',
      // Estilos base
      'flex grow flex-col',
      className
    )}
    {...props}
  />
));
DuelNotificationContent.displayName = 'DuelNotificationContent';

const DuelNotificationName = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-duel-notification-name',
      // Estilos base
      'mb-0 text-sm font-bold',
      className
    )}
    {...props}
  />
));
DuelNotificationName.displayName = 'DuelNotificationName';

const DuelNotificationButtons = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-notification-buttons',
      // Estilos base
      'mt-6 flex items-center gap-[42px] font-bold',
      className
    )}
    {...props}
  />
));
DuelNotificationButtons.displayName = 'DuelNotificationButtons';

export { DuelNotification, DuelNotificationContent, DuelNotificationName, DuelNotificationButtons };
